var posiSession = require("../utils/posi-session");

module.exports = function () {
  var LOG_EVENT_URL = SITE_SETTINGS.apiUrl + "/log",
    MAX_WAIT_TIME = 5000;

  var curSessionID = posiSession.getSession("sessionID");

  // disable logging if user is logged in
  var debugMode = SITE_SETTINGS.wpDebug == '1';
  if ($("body.logged-in").length > 0 && !debugMode) {
    return {
      log: function (data, cb) {
        if (typeof cb === "function") return cb();
      },
    };
  }

  return {
    log: function (data, cb) {
      var cbCalled = false,
        postData = {
          session_uid: curSessionID,
        };

      var wrappedCallback = $.noop;
      if (typeof cb === "function") {
        wrappedCallback = function () {
          if (cbCalled) return;

          cbCalled = true;
          cb();
        };
      }

      postData = $.extend(postData, data);
      function postToPosiLogger(cb) {
        if (!cb) cb = $.noop;
        $.post(LOG_EVENT_URL, postData, cb);
      }

      function postToHubspot(cb) {
        if (!cb) cb = $.noop;

        var hsPostData = $.extend(postData, {
          action: 'update_hubspot_from_session'
        });
        $.post(SITE_SETTINGS.ajaxurl, hsPostData, cb);
      }

      // send log event
      var posiLoggerCb = wrappedCallback;
      if (typeof ga === "function") {
        posiLoggerCb = false;
        var gaEvents = [];

        // transform original logger opts into array of ga events
        switch (data.event_type) {
          case "part-results":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Part Search",
              eventLabel: data.part_number,
            });

            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Part Results - 2D",
              eventLabel: data.part_number,
              eventValue: data.results_2d,
            });

            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Part Results - 3D",
              eventLabel: data.part_number,
              eventValue: data.results_3d,
            });

            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Part Validated",
              eventLabel: data.part_number,
              eventValue: data.validated ? 1 : 0,
            });

            break;

          case "registration-view":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Registration Viewed",
              eventLabel: data.part_number,
            });
            break;

          case "registration-submit":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Registration Submitted",
              eventLabel: data.part_number,
            });
            break;

          case "request-2d":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Request 2D",
              eventLabel: data.part_number,
            });
            break;

          case "request-3d":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Request 3D",
              eventLabel: data.part_number,
            });
            break;

          case "download-2d":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Download 2D",
              eventLabel: data.part_number,
            });
            break;

          case "download-3d":
            gaEvents.push({
              eventCategory: "Parts",
              eventAction: "Download 3D",
              eventLabel: data.part_number,
            });
            break;
        }

        var gaEventsReturned = 0;
        $.each(gaEvents, function (i, event) {
          event.hitCallback = function () {
            gaEventsReturned++;
            if (gaEventsReturned == gaEvents.length) {
              wrappedCallback();
            }
          };

          ga("gtm2.send", "event", event);
        });
      }

      postToHubspot(posiLoggerCb);
      postToPosiLogger(posiLoggerCb);

      setTimeout(wrappedCallback, MAX_WAIT_TIME);
    },
  };
};
